import { TramitType } from '@/interfaces/files';
import { getTramitTypes, getTransferTypes } from '@/services/files.service';
import { Effect, Reducer } from '@umijs/max';

export interface ModelType {
  namespace: string;
  state: {
    tramitsTypes: TramitType[];
    allZones: [];
  };
  effects: {
    fetchData: Effect;
    fetchTransferTypes: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'filesList',

  state: {
    tramitsTypes: [],
    allZones: [],
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      const [tramitsTypes] = yield all([call(getTramitTypes, payload)]);
      yield put({
        type: 'setData',
        payload: { tramitsTypes: tramitsTypes.data },
      });
    },

    *fetchTransferTypes({ payload }, { call, put, all }) {
      const [zones] = yield all([call(getTransferTypes, payload)]);
      yield put({
        type: 'setData',
        payload: { allZones: zones.data.filter((a: any) => a.enabled && a.name !== 'Web') },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
